module.exports = __webpack_public_path__ + "static/img/project8.4444d8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/project8.png
// module id = lCq6
// module chunks = 1